import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography, Box, Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { deleteManageByIdAction } from "../../../../actions/mangeActionV2";
import { showErrorToast, showSuccessToast } from "../../../../slices/toastSlice";
import { resetDelete } from "../../../../slices/manageSliceV2";
import Progress from "../../../../components/Loader/Progress ";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  deleteItem
}) => {


  const dispatch = useDispatch();


  const [isAbleToDelete, setIsAbleToDelete] = React.useState(false);
  const reducer = useSelector((s) => s.manageV2.deleteManage) || {};




  useEffect(() => {
    
    if (deleteItem?.booking?.shipmentDepartedDate == null ) {
      setIsAbleToDelete(true);
    } else {
      setIsAbleToDelete(false);
    }

  }, [deleteItem]);



  useEffect(()=>{
  
  
  
    return ()=>{
  
      dispatch(resetDelete())
  
  
    }
  
  
   },[])


   useEffect(()=>{
  
      if (reducer.loading === "failed"){
  
          dispatch(showErrorToast(reducer.errorMessage || t('Failed to delete shipment')));
      }
      if (reducer.loading === "succeeded"){

          dispatch(showSuccessToast(t('shipment  delete successfully')));
          onClose();
        
      }
  
  
    },[reducer.loading])




  const handelDelete = () => {
    dispatch(deleteManageByIdAction({ mode:"shipment", id: deleteItem.id }));
  };



  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("Confirm Delete")}</DialogTitle>
      <DialogContent>
        {!isAbleToDelete ? (
          <Typography color="error" variant="body1" gutterBottom>
            {t("Deletion is not allowed for shipments that have already departed.")}
          </Typography>
        ) : (
          <>
            <DialogContentText>
              {t("Warning: This action cannot be undone. Are you sure you want to delete the following shipment?")}
            </DialogContentText>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6" gutterBottom>
                {t("Shipment Details")}
              </Typography>
              <Typography variant="body2">
                <strong>{t("Booking Number")}:</strong> {deleteItem?.booking?.number}
              </Typography>
              <Typography variant="body2">
                <strong>{t("Vessel Name")}:</strong> {deleteItem?.booking?.vesselName}
              </Typography>
              <Typography variant="body2">
                <strong>{t("Voyage Number")}:</strong> {deleteItem?.booking?.voyageNumber}
              </Typography>
              <Typography variant="body2">
                <strong>{t("Destination")}:</strong> {deleteItem?.booking?.destination?.name}
              </Typography>
              {deleteItem?.containers?.map((container, index) => (
                <Box key={index} sx={{ mt: 2, pl: 2, borderLeft: 2, borderColor: 'primary.main' }}>
                  <Typography variant="subtitle2">
                    {t("Container")} {index + 1}: {container?.containerNumber} - {container?.sealNumber} - {container?.containerSize}
                  </Typography>
                  {container?.vehicles?.map((vehicle, vIndex) => (
                    <Typography key={vIndex} variant="body2" sx={{ ml: 2 }}>
                      • {t("Vehicle")} {vIndex + 1}: {vehicle?.make?.name} {vehicle?.model?.name} ({vehicle?.year}) - VIN: {vehicle?.vin}
                    </Typography>
                  ))}
                </Box>
              ))}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
          {reducer.loading === 'pending' ? <Progress Msg='Loading ...' /> :
          <>
        <Button onClick={onClose} variant="b2">
          {t("Cancel")}
        </Button>
        {isAbleToDelete && (
          <Button variant="b1" onClick={handelDelete}>
            {t("Delete")}
          </Button>
        )}
        </>
            }
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
